import { render } from "./ViewItemModal.vue?vue&type=template&id=253dba52"
import script from "./ViewItemModal.vue?vue&type=script&lang=js"
export * from "./ViewItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__